import React from 'react'
import { Outlet } from 'react-router-dom'

const IndividualDatas = () => {
  return (
    <div>
      
      <Outlet/>
 
    </div>
  )
}

export default IndividualDatas